import React, { useEffect, useRef, useState, memo } from 'react'
import styles from './index.scss';
import Modal from 'jd-library/Modal';
import { Button,FormCheck, withPortal} from 'jd-library';
import { useDispatch, useSelector } from 'react-redux';
import { updateBrandManufactureDetails, updateSpecificationData } from '../../../actions/productSpecification';
import { validation } from '../c-specification-slider/customActions';
import { updateEditProductDetail } from '../../../actions/products';


const AISuggestedSpex = (options) => {
    const productSpecification =  useSelector(state => state.productSpecification);
    const brandManufacturer = useSelector(state => state.brandManufacturer);
    const[editablePuvSpecs,updateEditableSpecs] = useState(JSON.parse(JSON.stringify(productSpecification.editablePuvSpecAttributes)));
    const dispatch =  useDispatch();
    
    const [selected,updateSelection] = useState([]);
    const [filteredList,updateFilteredList] = useState([]);
    const [specData,updateSpecData] = useState('');
    
    
    
    useEffect(() => {
        if(!selected.length) {
            filterSpecsToSend();
        }
        options.modalShowClickTrack();        
    },[])
    
    const filterSpecsToSend = () => {
        let newEditableSpecs = editablePuvSpecs;
        let notToDisplay = [];
        let spexAiData = options.data.data.filter(cur => {
            let specData = newEditableSpecs.find(ele => ele.s_dnm == cur.spec_name);
            if(specData) {
                if(['checkbox','checkboxautosuggest','dropdown','dropdownautosuggest'].includes(specData.s_type.toLowerCase())) {
                    let valInOptions = specData.s_type_options?.length && specData.s_type_options.find(s => s == cur.spec_values[0].spec_value)  ? cur.spec_values[0].spec_value : '';
                    let otherInOptions = specData.s_type_options?.length ? specData.s_type_options.find(el => el.toLowerCase().includes('other')) : '';
                    if(!valInOptions && otherInOptions) {
                        specData.userInput.value = otherInOptions;
                        specData.userInput.textboxValue = cur.spec_values[0].spec_value;
                        specData.isDependentTextBox = true;
                        specData.textBoxIsHidden = true;
                        specData.aiSpec = true;
                    }else if(valInOptions){
                        specData.userInput.value = cur.spec_values[0].spec_value;
                        specData.aiSpec = true;
                    }else{
                        notToDisplay.push({
                            name: cur.spec_name,
                            type: specData.s_type,
                            value: cur.spec_values[0].spec_value,
                            options: specData.s_type_options,
                            reason: 'Options Not Found'
                        })
                        return false;
                    }
                }else {
                    let result = validation(cur.spec_values[0].spec_value,{...specData});
                    if(!result.attributeValid) {
                        notToDisplay.push({
                            name: cur.spec_name,
                            type: specData.s_type,
                            value: cur.spec_values[0].spec_value,
                            reason: result.errorMessage
                        })
                        return false;
                    }else if(specData?.s_unit?.length) {
                        let unitInOptions = specData.s_unit.find(unit => unit.toLowerCase() == cur.spec_values[0].spec_unit.toLowerCase());
                        cur.spec_values[0].spec_unit = unitInOptions ? unitInOptions : specData.s_unit[0];
                        specData.userInput.textboxValue = cur.spec_values[0].spec_unit;
                        specData.aiSpec = true;
                    }
                    specData.userInput.value = cur.spec_values[0].spec_value;
                    specData.aiSpec = true;
                }
                return cur;
            }
            return false;
        });
        let newList = [];
        if(typeof options.data?.priceData?.data == 'object' && !Array.isArray(options.data?.priceData?.data)) {
            const priceString = `${options.data.priceData.data.priceRange ? '₹'+Number(options.data.priceData.data.priceRange.min).toLocaleString('en-IN') + ' - ' + '₹'+Number(options.data.priceData.data.priceRange.max).toLocaleString('en-IN') : '₹'+Number(options.data.priceData.data.singlePrice).toLocaleString('en-IN')} ${options.data.priceData.unit_of_measurment ? ' per ' + options.data.priceData.unit_of_measurment : ''}`
            newList.push({
                spec_name: 'Price',
                spec_values: [{
                    spec_value: priceString,
                    spec_unit: ''
                }]
            })
            spexAiData.unshift({
                spec_name: 'Price',
                spec_values: [{
                    spec_value: priceString,
                    spec_unit: ''
                }]

            })
        }
        spexAiData.map(cur => {
            newList.push(cur)
        })
        if(!spexAiData.length) {
            options.onHidden();
            options.onAISpecDataSaved();
        }
        updateFilteredList(spexAiData);
        updateSelection(newList);
        updateEditableSpecs(newEditableSpecs);
        console.log('Rejected Specs : ',notToDisplay);
    }

    const handleSubmitSpec = () => {
        if (!selected.length){
            options.saveClickTrack(filteredList.length, selected.length)
            window.history.back()
            return;
        }
        const specsSelected = selected.filter(ele => ele.spec_name != 'Price');
        const brandSpec = specsSelected.find(ele => ele.spec_name == 'Brand');
        if(brandSpec) {
            dispatch(updateBrandManufactureDetails({
                ...brandManufacturer,
                brandName: brandSpec.spec_values[0].spec_value,
                sendDetails: brandManufacturer.sendDetails.map(spec => {
                    if(spec.sid == '122'){
                        spec.values = [brandSpec.spec_values[0].spec_value];
                    }
                    return spec;
                })
            }))
        }
        const aiPrice = selected.find(el => el.spec_name == 'Price');
        if(aiPrice) {
            const isPriceRange = aiPrice.spec_values[0].spec_value.includes('-');
            dispatch(updateEditProductDetail([{
                key: 'aiPriceObj',
                value: {
                    isMaxQtyNotApplicableForRange: false,
                    isSinglePrice: !isPriceRange,
                    maxPrice: isPriceRange ? options.data.priceData.data.priceRange.max : '',
                    minPrice: isPriceRange ? options.data.priceData.data.priceRange.min : '',
                    singlePrice: isPriceRange ? '' : options.data.priceData.data.singlePrice,
                    actualPrice: isPriceRange ? '' : (options.productOrService == 'service' ? options.data.priceData.data.singlePrice : '')
                }
            },{
                key: 'priceLogId',
                value: options.data.priceLogId || ''
            }]))
            if(options.data.priceData.unit_of_measurment) {
                dispatch(updateEditProductDetail({
                    key: 'unitOfMeasurement',
                    value: options.data.priceData.unit_of_measurment
                }))
            }

        }
        let newEditableSpecs = [...productSpecification.editablePuvSpecAttributes];
        newEditableSpecs = newEditableSpecs.map(item => {
            let selectedSpec = specsSelected.find(ele => ele.spec_name.toLowerCase() == item.s_dnm.toLowerCase());
            if(selectedSpec) {
                return editablePuvSpecs.find(ele => ele.s_dnm.toLowerCase() == item.s_dnm.toLowerCase());
            }
            return  item;
        })
        let payload = {editablePuvSpecAttributes: newEditableSpecs };
        payload = {
            savedPuvSpecAttributes: newEditableSpecs,
            editablePuvSpecAttributes: newEditableSpecs
        }
        dispatch(updateSpecificationData(payload))
        updateSpecData(payload);
        options.saveClickTrack(filteredList.length, specsSelected.length)
        window.history.back()        
        
    }

    
    const Item = memo((data) => {
        
        return (
            <div className={styles['item']}>
                <FormCheck
                    label={  
                        <span className={styles['item-label']}>
                            <span className={styles['label-title']}>
                                {data.spec_name} 
                            </span>
                            <span className={styles['label-value']}>
                                : {data.spec_values[0].spec_value} {data.spec_values[0].spec_unit}
                            </span>
                        </span>
                        }
                    checked={data.isChecked}
                    className={styles['label-holder']}
                    labelClass={styles['item-label']}
                    onChange={(e) => {
                        let selectedData = [...selected];
                        if(e.target.checked) {
                            selectedData.push(data)
                        }else {
                            let index = selected.findIndex(cur => cur.spec_name === data.spec_name);
                            selectedData.splice(index,1);
                        }
                        updateSelection(selectedData);
                    }}
                />
            </div>
        )
    })



    return (
        filteredList.length ? 
        <Modal
        settings={{
            modalId: 'ai-spec-modal',
            variant: 'action',
            className: styles['ai-spec-modal']
        }}
        backdropStatic={true}

        onHidden={() => {
            options.onHidden();
            options.onAISpecDataSaved(specData || '');
        }
    }
    >
        <Modal.CloseIcon />
        <Modal.Header className={styles['modal-header']}>
            <div className={styles['ai-txt']}>
                Add Missing Information
            </div>
            <div>
             Add the following missing information which will help you get more leads
            </div>
        </Modal.Header>

        <Modal.Body className={styles['modal-body']}>
            <div className={styles['result-holder']} body-scroll-lock-ignore='true'>
                {filteredList.map(cur => {
                    return <Item {...cur} isChecked={selected.find(ele => ele.spec_name === cur.spec_name)} />
                })}
               
            </div>
            <div className={styles['lower-sec-container']}>
            <div className={styles['lower-sec']}>
              You can uncheck the information which is irrelevant
            </div>
            <Button
                className={styles['save-btn']}
                children={'Save & Continue'}
                clickHandler={handleSubmitSpec} 
                // showLoader={props.showBtnLoader}
            />
            </div>
        </Modal.Body>
    </Modal>
    : null
  )
}



export default  withPortal(AISuggestedSpex)